import React  from 'react';

import MaternalBibliographyContent from "../content/MaternalBibliographyContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function MaternalBibliography() {
    return(
        <>
        <Navbar />
        <MaternalBibliographyContent/>
        <Footer />        
        </>
    );
}

export default MaternalBibliography;